import { Component, input, output } from '@angular/core'

import type { DateRange } from '../../components/filter-date-range'
import { FilterDateRange } from '../../components/filter-date-range'
import { filterAccordion } from '../filter-accordion'

@Component({
  selector: 'dhp-filter-date-range-accordion',
  templateUrl: './filter-date-range-accordion.html',
  imports: [filterAccordion, FilterDateRange],
})
export class FilterDateRangeAccordion {
  //region Inputs
  // The name of the filter.
  public readonly filterName = input.required<string>()
  //endregion inputs

  //region Outputs
  // The date range to filter on, with a from and to date.
  public readonly dateRangeOutput = output<DateRange | null>()
  //endregion Outputs
}
